import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AlertCircle } from "lucide-react";
import { FaSync } from "react-icons/fa";
import { fetchRiskTimeline, fetchIdentityDistributiontData } from "../../store/slices/visualSlice"; // Adjust path to store
import { Header } from "../../components/layout";
import RiskTimeLineChart from "../../components/modules/Visuals/RiskTimeLineChart";
import RiskDashboard from '../../components/modules/Visuals/DepartmentChart';
import MFARegistrationByDepartment from '../../components/modules/Visuals/MFA_Registration/MFARegistrationByDepartment'
import "./Visuals.css"
import IdentityDistributionCard from "../../components/modules/Visuals/IdentityDistributionCard/IdentityDistributionCard";
const Visuals = () => {
  const dispatch = useDispatch();
  const { timeline, loading, error, distributionData, distributionLoading, distributionError } = useSelector((state) => state?.visuals);
  useEffect(() => {
    dispatch(fetchRiskTimeline());
    dispatch(fetchIdentityDistributiontData());
  }, [dispatch]);

  // Formats raw API data to be fed into the chart
  const mappedTimeline = (timeline || [])?.map((item) => {
    const date = new Date(item?.timestamp);
    const formattedTime = !isNaN(date)
      ? date.toLocaleDateString([], {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
      : "Unknown Time";

    return {
      time: formattedTime,
      postureScore: item?.global_posture_score ?? 0,
      identityCount: item?.total_identity_count ?? 0,
      humans: item?.total_humans ?? 0,
      nonHumans: item?.total_non_humans ?? 0,
    };
  });

  return (
    <div
      // className="auth-activity-page"
      style={{ padding: "24px", boxSizing: "border-box" }}>
      {/* Page Header */}
      <Header title={"Posture Visuals"} subtitle={"Posture Visuals graph for Identities"} />

      {/* Global Error Banner Notification */}
      {error && (
        <div
          // className="auth-activity-page__error"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "12px 16px",
            backgroundColor: "#fef2f2",
            border: "1px solid #fee2e2",
            borderRadius: "8px",
            marginBottom: "24px",
            color: "#ef4444",
            fontSize: "14px"
          }}
        >
          <div
            // className="auth-activity-page__error-content"
            style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <AlertCircle size={16} />
            <span>{error}</span>
          </div>
          <button
            // className="auth-activity-page__error-retry"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px",
              backgroundColor: "#ffffff",
              border: "1px solid #fee2e2",
              padding: "6px 12px",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "12px",
              fontWeight: "500",
              color: "#ef4444"
            }}
            onClick={() => dispatch(fetchRiskTimeline())}
          >
            <FaSync size={10} /> Retry
          </button>
        </div>
      )}

      {/* Main Corporate Analytics Layout Deck Grid */}
      <div
        // className="visuals-dashboard-deck"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "32px",
          marginTop: "24px"
        }}
      >
        {/* Layer 1: Timeline Analysis Component */}
        <div
        //  className="timeline-chart-section"
        >
          <RiskTimeLineChart data={mappedTimeline} loading={loading} />
        </div>

        {/* Layer 2: Core Department Breakdown Segment Grid */}
        <div
        // className="department-chart-section"
        >
          <RiskDashboard />
        </div>

        <div className="distribution-grid-layout">
          <div>
            <MFARegistrationByDepartment />
          </div>
          <div>
            <IdentityDistributionCard apiResponse={distributionData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Visuals;